export default __webpack_public_path__ + "static/media/packet-2.5ff11a75.svg";